import { render } from "./TransferReceipt.vue?vue&type=template&id=3b1be148&scoped=true"
import script from "./TransferReceipt.vue?vue&type=script&lang=js"
export * from "./TransferReceipt.vue?vue&type=script&lang=js"

import "./TransferReceipt.vue?vue&type=style&index=0&id=3b1be148&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1be148"]])

export default __exports__